import React from 'react'

import { View, TouchableOpacity } from 'react-native'
import * as util from 'x/utils/util'
import p from 'x/config/platform-specific'
import _ from 'lodash'

import { COLORS, STYLES } from 'x/config/styles'
// import ReportProductDailySales from '../report/ReportProductDailySales'
// import ReportPayment from '../report/ReportPayment'
// import ReportHelperSales from '../report/ReportHelperSales'
import XIcon from 'xui/components/XIcon'
import BaseImportProductQTYView from 'x/modules/importExcel/BaseImportProductQTYView'
import XCustomHeader from 'xui/components/XCustomHeader'

import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
import XCard from 'xui/components/XCard'
import Box from 'xui/components/Box'
import XText from 'xui/components/XText'
import XFooterImportExcel from 'xui/components/XFooterImportExcel'
import XSpinner from 'xui/components/XSpinner'
import HStack from 'xui/components/HStack'
import VStack from 'xui/components/VStack'
import FillExtraDataCard from '../inventory/FillExtraDataCard'

export default abstract class BaseUIImportProductQTYView extends BaseImportProductQTYView {
  abstract _handleOnDownloadFile(url: string, fileName: string): Promise<void>

  abstract _renderDropzone(): JSX.Element

  abstract onPressUpload(): void

  renderCustomHeader = () => {
    // const { navigation } = this.props
    // const { mode } = this.state
    // const isEditMode = mode === EDIT
    const leftBtn = { backIcon: true, onPressItem: () => this._goBack() }
    // if (isEditMode) {
    //   // @ts-ignore
    //   leftBtn = { label: `บันทึก`, onPressItem: () => util.setStatePromise(this, { mode: VIEW }) }
    // }
    return (
      <XCustomHeader
        title={`ปรับจำนวน${p.op.t('qty')}\nแบบเห็นรายการสินค้าทั้งร้าน`}
        headerLeftProps={leftBtn}
        // headerRightProps={{ label: `แก้ไข`, onPressItem: () => util.setStatePromise(this, { mode: EDIT }) }}
      />
    )
  }

  _delayDownloadTemplate = async () => {
    util.setStatePromise(this, {
      disabledDownloadTemplate: true,
    })
    await util.delay(5000)
    util.setStatePromise(this, {
      disabledDownloadTemplate: false,
    })
  }

  _downloadTemplate = async () => {
    this._delayDownloadTemplate()
    const storeId = this.props.selectedStore.get('id')
    const url = util.getProductQtyUpdateTemplate({
      store_id: storeId,
    })
    // console.log('url => ', url)
    const now = util.getTimeFormatYYYYMMDDhhmmss()
    const fileName = `mass_product_qty_update_template_${storeId}_${now}.xlsx`
    await this._handleOnDownloadFile(url, fileName)
    // const res = await api.getV2(api.GET_EXCEL_PRODUCT_IMPORT_TEMPLATE, apiOptions)
    // console.log('res => ', res)
    // Linking.openURL(linkDownload)
  }

  _renderDownloadTemplateView = () => {
    const { disabledDownloadTemplate } = this.state
    let textBtnColor = COLORS.TEXT_ACTIVE
    let borderBtnColor = COLORS.APP_MAIN
    if (disabledDownloadTemplate) {
      textBtnColor = COLORS.TEXT_INACTIVE
      borderBtnColor = COLORS.TEXT_INACTIVE
    }
    return (
      <Box
        style={{
          width: '100%',
          justifyContent: 'center',
        }}
      >
        <XText variant='active'>{`ใช้เพื่อแก้ไขจำนวน${p.op.t('qty')}สำหรับสินค้าทีละหลายรายการ`}</XText>
        <XText variant='active' bold>
          ขั้นตอน:
        </XText>

        <XText variant='active'>{`1) กดปุ่ม "ดาวน์โหลด Excel จำนวน${p.op.t('qty')} ณ ปัจจุบัน" เพื่อให้ได้รายการสินค้าและจำนวน${p.op.t(
          'qty'
        )}ที่ล่าสุดก่อนแก้ไข`}</XText>
        <XText color={COLORS.APP_MAIN}>หมายเหตุ: ในทุกๆครั้งที่ต้องการแก้ไข ต้องโหลดไฟล์นี้ใหม่ทุกครั้งเพื่อข้อมูลที่ตรงกับปัจจุบัน</XText>
        <Box h='2' />
        <TouchableOpacity
          disabled={disabledDownloadTemplate}
          onPress={() => this._downloadTemplate()}
          style={{
            width: 300,
            flexDirection: 'row',
            height: 50,
            borderColor: borderBtnColor,
            borderRadius: 7,
            borderWidth: 0.8,
            padding: 5,
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
          }}
        >
          <XIcon
            name='file-excel'
            family='AntDesign'
            style={{ flex: 0, minWidth: 25, width: 25, color: borderBtnColor, fontSize: STYLES.FONT_ICON_SMALLER }}
          />
          <XIcon
            name='equal-box'
            family='MaterialCommunityIcons'
            style={{ flex: 0, minWidth: 25, width: 25, color: '#2F75B5', fontSize: STYLES.FONT_ICON_NORMAL }}
          />
          <Box w='1' />

          <HStack flex={1} alignItems='center' justifyContent='center'>
            <XText color={textBtnColor}>{`ดาวน์โหลด Excel จำนวน${p.op.t('qty')}สินค้า ณ ปัจจุบัน`}</XText>
          </HStack>
        </TouchableOpacity>
        <Box h='2' />
        {/* <View style={{ height: 15 }} /> */}
        <XText variant='active'>{`2) เปิดไฟล์ Excel เพื่อแก้ไขจำนวน${p.op.t(
          'qty'
        )}ในช่องสีเขียว เฉพาะรายการสินค้าที่ต้องการแก้ไขจำนวน${p.op.t('qty')}`}</XText>
        {/* <View style={{ height: 5 }} /> */}
        <XText variant='active'>3) เลือก ไฟล์ Excel ที่แก้ไขแล้ว และกดปุ่ม "อัพโหลด"</XText>
      </Box>
    )
  }

  _renderFillExtraDataCard = () => {
    const { note, orderId, refCode, isFillExtraDataExpanded } = this.state
    const mode = 'set'
    return (
      <XCard overflow='hidden' mt='2'>
        <FillExtraDataCard
          isFillExtraDataExpanded={isFillExtraDataExpanded}
          note={note}
          refCode={refCode}
          orderId={orderId}
          onChangeNote={(text) => this.setState({ note: text })}
          onChangeRefCode={(text) => this.setState({ refCode: text })}
          onChangeOrderId={(text) => this.setState({ orderId: text })}
          mode={mode}
          onPressFillExtraDataToggle={(next) => this.setState({ isFillExtraDataExpanded: next })}
          selectedReason={null}
          onSelectReason={(reason, index) => null}
          colorScheme={'purple'}
        />
      </XCard>
    )
  }

  _renderBtnUpload = () => {
    const { fileUpload } = this.state
    const btnBGColor = _.isNil(fileUpload) ? COLORS.BG_LIGHT_GREY : COLORS.APP_MAIN
    const btnBorderColor = _.isNil(fileUpload) ? COLORS.TEXT_INACTIVE : COLORS.APP_MAIN
    const textBtnColor = _.isNil(fileUpload) ? COLORS.TEXT_INACTIVE : COLORS.WHITE
    return (
      <View style={{ width: '100%', height: 100, justifyContent: 'center', alignItems: 'center', backgroundColor: COLORS.WHITE }}>
        <TouchableOpacity
          onPress={() => this.onPressUpload()}
          disabled={_.isNil(fileUpload)}
          style={{
            width: 180,
            flexDirection: 'row',
            height: 30,
            borderColor: btnBorderColor,
            backgroundColor: btnBGColor,
            borderRadius: 7,
            borderWidth: 0.8,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <XIcon
            name='upload'
            family='AntDesign'
            style={{ flex: 0, minWidth: 25, width: 25, color: textBtnColor, fontSize: STYLES.FONT_ICON_SMALLER }}
          />
          <XText color={textBtnColor} pl='2'>
            อัพโหลด
          </XText>
        </TouchableOpacity>
        {/* <Text style={{ fontSize: STYLES.FONT_SIZE_NORMAL, color: COLORS.TEXT_INACTIVE, paddingLeft: 4, paddingRight: 4, paddingTop: 6 }}>
          {`(ระบบอาจใช้เวลาประมาณ 40 วินาที ต่อ 1 บัญชี ดังนั้นเมื่อกดปุ่มอัพโหลด กรุณาเปิดหน้าต่างนี้ทิ้งไว้จนกว่าจะเสร็จ)`}
        </Text> */}
      </View>
    )
  }

  callBackOnPressFooter = async (result: boolean) => {
    // console.log('result => ', result)
    if (!result) {
      this._stopLoading()
      return
    }
    await util.delay(500)
    this._stopLoading()
    this.onPressUpload()
  }

  renderLoading = () => {
    if (!this.state.isLoading) {
      return null
    }
    return (
      <View
        style={{
          // zIndex: 999,
          position: 'absolute',
          width: '100%',
          height: 800,
          backgroundColor: 'rgba(52, 52, 52, 0.7)',
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
          paddingTop: 0,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          marginTop: 0,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <XSpinner />
      </View>
    )
  }

  _renderErrorMessage = () => {
    const { errMessage } = this.state
    if (_.isNil(errMessage) || errMessage.length === 0) {
      return null
    }
    return (
      <VStack borderRadius={7} bgColor={COLORS.RED_SOFT} h='32' mt='2' alignItems={'center'} justifyContent='center'>
        <XText color={COLORS.RED} textAlign={'center'}>
          {errMessage}
        </XText>
      </VStack>
    )
  }

  render() {
    // console.log(` RENDER !! `, this.menuItems)
    const { fileUpload, isLoading } = this.state
    const fileSize = fileUpload && fileUpload.size ? fileUpload.size : null
    return (
      <XContainer>
        {this.renderCustomHeader()}
        <XContent p='2'>
          <XCard p='2'>
            {this._renderDownloadTemplateView()}
            {this._renderErrorMessage()}
            {this._renderFillExtraDataCard()}
            <Box h='2' />
            {this._renderDropzone()}
            {/* {this._renderBtnUpload()} */}
          </XCard>
        </XContent>
        <XFooterImportExcel
          fileSize={fileSize}
          // fileName={fileName}
          callBackOnPress={(result: boolean) => {
            this._startLoading()
            this.callBackOnPressFooter(result)
          }}
          isDisabled={isLoading}
        />
        {this.renderLoading()}
      </XContainer>
    )
  }
}

// <XContent
//   style={[
//     NO_MARGIN_PADDING,
//     {
//       flex: 1,
//       flexDirection: 'column',
//       // backgroundColor: 'tomato',
//     },
//   ]} />
